import Navbar from './components/Navbar';
import Hero from './components/Hero';
import PresentationVideo from './components/PresentationVideo';
import WhyUs from './components/WhyUs';
import Remorque from './components/Remorque';
import Tarifs from './components/Tarifs';
import Personalisation from './components/Personalisation';
import Services from './components/Services';
import Devis from './components/Devis';
import About from './components/About';
import CTA from './components/CTA';
import Contact from './components/Contact';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';

export default function Home() {
  return (
    <div className="text-gray-800 bg-[#fbf9f4]">
      <Navbar />
      <main>
        <Hero />
        <PresentationVideo />
        <Remorque />
        <WhyUs />
        <Tarifs />
        <Personalisation />
        <Devis />
        <Services />
        <About />
        <CTA />
        <Contact />
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
}
